// Loaded via <link> in public/index.html (see preconnect + stylesheet tags).
// Manrope carries the UI; JetBrains Mono renders identifiers, timestamps, and other data.
export const fontFamilyDisplay = '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const fontFamilyMono = '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, Consolas, monospace';
